<template>
  <vs-popup
    :title="
      `${$t('dashboard.amendments.popup.heading1')} > ${organization.name}`
    "
    :active.sync="showPopup"
    ref="popup"
  >
    <div class="popup">
      <!-- HEADER -->
      <vs-row vs-w="12" class="mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="12">
          <div v-if="request.reviewed">
            <vs-chip v-if="request.reviewed === true" color="success">
              Genehmigt am {{ request.reviewed_at | moment("DD.MM.YYYY") }}
            </vs-chip>
          </div>
          <div v-else-if="request.reviewed === false">
            <vs-chip v-if="request.reviewed === false" color="danger">
              Abgelehnt am {{ request.reviewed_at | moment("DD.MM.YYYY") }}
            </vs-chip>
          </div>
          <div v-else>
            <vs-chip v-if="request.reviewed === null" color="primary">
              Erstellt am
              {{ request.created_at | moment("DD.MM.YYYY") }}</vs-chip
            >
          </div>
        </vs-col>
      </vs-row>

      <!-- BODY -->
      <vs-row class="ps-3 pe-3">
        <vs-row>
          <vs-col vs-w="6"><strong>Original</strong></vs-col>
          <vs-col vs-w="6"><strong>Änderung</strong></vs-col>
        </vs-row>

        <vs-row class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.first-name')"
              v-model="person.first_name"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.first-name')"
              :value="getChangedField('first_name')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.last-name')"
              v-model="person.last_name"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.last-name')"
              :value="getChangedField('last_name')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.date-birth')"
              :value="formatDate(person.date_of_birth)"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.date-birth')"
              :value="getChangedField('date_of_birth')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.function')"
              v-model="person.role"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.function')"
              :value="getChangedField('role')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="
                $t('dashboard.amendments.popup.driver-license')
              "
              v-model="person.driver_license_class"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="
                $t('dashboard.amendments.popup.driver-license')
              "
              :value="getChangedField('driver_license_class')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.department')"
              v-model="person.department"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="$t('dashboard.amendments.popup.department')"
              :value="getChangedField('department')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_1"
              v-model="person.extra_1"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_1"
              :value="getChangedField('extra_1')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_2"
              v-model="person.extra_2"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_2"
              :value="getChangedField('extra_2')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_3"
              v-model="person.extra_3"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_3"
              :value="getChangedField('extra_3')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_4"
              v-model="person.extra_4"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_4"
              :value="getChangedField('extra_4')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_5"
              v-model="person.extra_5"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_5"
              :value="getChangedField('extra_5')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row v-if="!isPreconfLayout" class="mt-3">
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_6"
              v-model="person.extra_6"
              readonly
            />
          </vs-col>
          <vs-col vs-w="6">
            <vs-input
              class="simple-input w-100 pe-2"
              :label-placeholder="extraLabels.extra_6"
              :value="getChangedField('extra_6')"
              readonly
            />
          </vs-col>
        </vs-row>

        <vs-row class="mt-3">
          <vs-col vs-w="6">
            <img
              v-if="profileImage"
              class="amendment-image"
              :src="'data:image/png;base64, ' + personImg64"
            />
          </vs-col>
          <vs-col vs-w="6">
            <img
              v-if="profileImage"
              class="amendment-image"
              :src="'data:image/png;base64, ' + requestImg64"
            />
          </vs-col>
        </vs-row>
      </vs-row>

      <!-- ACTION BUTTONS -->
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="left" vs-align="left" vs-w="6">
          <vs-button
            v-if="request.reviewed === null"
            class="pop-btn"
            color="danger"
            type="filled"
            icon="cancel"
            @click="reviewAmendment('false')"
            >{{ $t("decline") }}</vs-button
          >
        </vs-col>

        <vs-col vs-type="flex" vs-justify="right" vs-align="right" vs-w="6">
          <vs-button
            v-if="request.reviewed === null"
            class="pop-btn"
            color="primary"
            type="filled"
            icon="done"
            @click="reviewAmendment('true')"
            >{{ $t("Annehmen") }}</vs-button
          >
          <vs-button
            class="pop-btn"
            color="primary"
            type="filled"
            icon="close"
            @click="showPopup = !showPopup"
            >{{ $t("cancel") }}</vs-button
          >
        </vs-col>
      </vs-row>

      <!-- DEBUG MODE -->
      <vs-row v-if="isDebugMode">
        <h1>organization</h1>
        {{ organization }}
        <h1>Person</h1>
        {{ person }}
        <h1>REQUEST</h1>
        {{ request }}
      </vs-row>
    </div>
  </vs-popup>
</template>

<script>
import Vue from "vue";

import _ from "lodash";

export default Vue.extend({
  // props:['request'],

  data() {
    return {
      request: {},
      person: {},
      showPopup: false,
      isPreconfLayout: false,
      temp: {},
    };
  },

  computed: {
    extraLabels() {
      if (!this.request) return {};
      if (this.temp?.preconfigured_layout_id === 2) {
        return {
          extra_1: this.$t("Jugendflamme I"),
          extra_2: this.$t("Jugendflamme II"),
          extra_3: this.$t("Jugendflamme III"),
          extra_4: this.$t("Leistungsspange"),
          extra_5: this.$t("Bundeswettbewerb"),
          extra_6: this.$t("Eintrittsdatum"),
        };
      } else {
        return {
          extra_1: this.temp?.extra_1_caption || this.$t("Extra1"),
          extra_2: this.temp?.extra_2_caption || this.$t("Extra2"),
          extra_3: this.temp?.extra_3_caption || this.$t("Extra3"),
          extra_4: this.temp?.extra_4_caption || this.$t("Extra4"),
          extra_5: this.temp?.extra_5_caption || this.$t("Extra5"),
          extra_6: this.temp?.extra_6_caption || this.$t("Extra6"),
        };
      }
    },
    organization() {
      return this.$store.getters["organization/getOrganization"];
    },
    profileImage() {
      if (this.request.hasOwnProperty("changed_fields")) {
        if (this.request.changed_fields.hasOwnProperty("profile_image_id")) {
          return true;
        }
      }
      return false;
    },
    // person() {
    //     return this.$store.getters['person/getPerson']
    // }
  },
  watch: {
    showPopup(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const content = this.$refs.popup.$el.querySelector(
            ".vs-popup--content",
          );
          if (content) content.scrollTop = 0;
        });
      }
    },
  },

  methods: {
    formatDate(value) {
      if (!value) return value;
      if (value.includes("T")) value = value.split("T")[0];
      const parts = value.split("-");
      if (parts.length !== 3) return value;
      return `${parts[2]}.${parts[1]}.${parts[0]}`;
    },
    open() {
      this.showPopup = true;
    },
    async openEdit(request) {
      // Load Person
      await this.$store.dispatch("person/loadPerson", request.person_id);

      let person = this.$store.getters["person/getPerson"];
      this.person = _.cloneDeep(person);

      this.person.date_of_birth = this.formatDate(this.person.date_of_birth);
      if (this.person.extra_1)
        this.person.extra_1 = this.formatDate(this.person.extra_1);
      if (this.person.extra_2)
        this.person.extra_2 = this.formatDate(this.person.extra_2);
      if (this.person.extra_3)
        this.person.extra_3 = this.formatDate(this.person.extra_3);
      if (this.person.extra_4)
        this.person.extra_4 = this.formatDate(this.person.extra_4);
      if (this.person.extra_5)
        this.person.extra_5 = this.formatDate(this.person.extra_5);
      if (this.person.extra_6)
        this.person.extra_6 = this.formatDate(this.person.extra_6);

      // Load Image
      if (request.changed_fields.hasOwnProperty("profile_image_id")) {
        this.personImg64 = await this.$store.dispatch(
          "core/getImage64",
          person.profile_image_id,
        );
        this.requestImg64 = await this.$store.dispatch(
          "core/getImage64",
          request.changed_fields.profile_image_id,
        );
      }

      // Load Organization
      await this.$store.dispatch(
        "organization/loadOrganization",
        this.person.organisation_id,
      );
      const organization = this.$store.getters["organization/getOrganization"];

      //Load Layout
      await this.$store.dispatch(
        "layout/loadLayout",
        organization.id_card_layout_id,
      );
      const temp = this.$store.getters["layout/getLayout"];
      this.temp = temp;
      if (
        temp.preconfigured_layout_id === 1 ||
        temp.preconfigured_layout_id === 3
      ) {
        this.isPreconfLayout = true;
      } else {
        this.isPreconfLayout = false;
      }

      // Load Request
      if (request.changed_fields.hasOwnProperty("date_of_birth")) {
        request.changed_fields.date_of_birth = this.formatDate(
          request.changed_fields.date_of_birth,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_6")) {
        request.changed_fields.extra_6 = this.formatDate(
          request.changed_fields.extra_6,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_1")) {
        request.changed_fields.extra_1 = this.formatDate(
          request.changed_fields.extra_1,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_2")) {
        request.changed_fields.extra_2 = this.formatDate(
          request.changed_fields.extra_2,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_3")) {
        request.changed_fields.extra_3 = this.formatDate(
          request.changed_fields.extra_3,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_4")) {
        request.changed_fields.extra_4 = this.formatDate(
          request.changed_fields.extra_4,
        );
      }
      if (request.changed_fields.hasOwnProperty("extra_5")) {
        request.changed_fields.extra_5 = this.formatDate(
          request.changed_fields.extra_5,
        );
      }
      this.request = request;

      this.showPopup = true;
    },

    getChangedField(fieldName) {
      if (this.request?.changed_fields?.[fieldName]) {
        const value = this.request.changed_fields[fieldName];
        return this.formatDate(value);
      }
      return "";
    },
    async reviewAmendment(value) {
      await this.$store.dispatch("changeRequest/reviewAmendment", {
        id: this.request.id,
        value: value,
      });
      this.showPopup = false;
    },
  },
});
</script>

<style scoped>
.amendment-image {
  max-width: 100%;
  height: auto;
  display: block;
}
</style>
<style></style>
